import { useEffect, useState } from 'react';
import { useActivePlayer } from '@/context/ActivePlayerContext';
import { ModuleName } from '@/constants';
import useOnlineStatus from '@/hooks/useOnlineStatus';
import { UserSettingsHelper } from '@/library';
import EditNavModal from './EditNavModal';
import styles from './Subnavbar.module.scss';

function Subnavbar() {
  const { activeModule, setModule, isLoading, moduleOrder, setModuleOrder, permissions } = useActivePlayer();
  const isOnline = useOnlineStatus();
  const [showEditNav, setShowEditNav] = useState(false);
  const availableModules = UserSettingsHelper.getAvailableModules(moduleOrder, isOnline, permissions?.tourPageSettings);

  useEffect(() => {
    if (isLoading) return;
    // [class*="className"] - partial match operation
    // Auto-scroll to currently selected module
    document.querySelector('[class*="activeModule"]')?.scrollIntoView({
      behavior: 'smooth',
      inline: 'center',
      block: 'nearest',
    });
  }, [isLoading]);

  const handleSaveOrder = (newOrder: ModuleName[]) => {
    setModuleOrder(newOrder);
  };

  return (
    <>
      <nav className={styles.subnavbar}>
        <div className={styles.modulesWrapper}>
          {!isLoading &&
            availableModules.map((module) => (
              <div key={module} className={`${styles.module} ${module === activeModule ? styles.activeModule : ''}`} role="button" onClick={() => setModule(module)}>
                {module}
              </div>
            ))}
          {!isLoading && isOnline && (
            <div className={styles.editNavButton} role="button" onClick={() => setShowEditNav(true)}>
              Edit Nav
            </div>
          )}
        </div>
      </nav>
      <EditNavModal isOpen={showEditNav} onClose={() => setShowEditNav(false)} moduleOrder={availableModules} onSave={handleSaveOrder} tourPageSettings={permissions?.tourPageSettings} />
    </>
  );
}

export default Subnavbar;
